export default "__VITE_ASSET__CZdQvfKn__"